import React from 'react';
import useActionDropdown from 'hooks/useActionDropDown';
import t from 'utils/translationHelper';

import MenuDropdownItem from '@alpha/ui-lib/ui/atoms/MenuDropdownItem/MenuDropdownItem';
import { ClickAwayListener, Typography } from '@alpha/ui-lib/ui/external';
import APMenu from '@alpha/ui-lib/ui/molecules/Menu/Menu';
import { faEllipsisH, IconDefinition } from '@fortawesome/pro-regular-svg-icons';

import useStyles from './index.style';

interface IProps {
  menuItems: {icon: IconDefinition, text: string, action: () => void}[],
}

const RemittersActions: React.FC<IProps> = ({
  menuItems,
}: IProps) => {
  const classes = useStyles();

  const {
    open,
    setOpen,
    menuCloseCount,
    setMenuCloseCount,
  } = useActionDropdown({});

  const handleClickAway = (): void => {
    if (menuCloseCount === 1) {
      setMenuCloseCount(menuCloseCount + 1);
    }
  };

  const handleClose = (): void => {
    setMenuCloseCount(0);
  };

  const menuItemsToDisplay = menuItems.map((r, index) => ({
    content: (
      <Typography data-testid="actionDropDown-items">
        {t(r.text)}
      </Typography>
    ),
    icon: r.icon,
    onClick: r.action,
    underline: index !== menuItems.length - 1,
  }));

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div data-testid="action-dropdown" className={classes.wrapper}>
        <APMenu
          open={Boolean(open)}
          setOpen={setOpen}
          anchorEl={open}
          disableBackdropClick={menuCloseCount === 1}
          onClose={handleClose}
          buttonProps={{ style: { height: 30, width: 30, minWidth: 0 } }}
          buttonTitle=""
          // @ts-expect-error - icon type mismatch
          icon={faEllipsisH}
          actions
        >
          {menuItemsToDisplay.map((item) => (
            <MenuDropdownItem setOpen={setOpen}>{item}</MenuDropdownItem>
          ))}
        </APMenu>
      </div>
    </ClickAwayListener>
  );
};

export default RemittersActions;
